import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_3 = { class: "text-3xl py-10" }
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { class: "grid grid-cols-6 gap-3 mb-5" }
const _hoisted_6 = { class: "grid grid-cols-4 gap-3 items-start" }
const _hoisted_7 = { class: "grid-cols-1 grid gap-3" }
const _hoisted_8 = { class: "grid-cols-1 grid gap-3" }
const _hoisted_9 = {
  key: 0,
  class: "bg-white flex flex-col justify-between p-3 h-36"
}
const _hoisted_10 = { class: "flex-shrink font-bold text-sm" }
const _hoisted_11 = { class: "xs:flex justify-between items-end text-center xs:text-left" }
const _hoisted_12 = { class: "font-bold text-xl leading-none" }
const _hoisted_13 = { class: "mt-2 xs:mt-0" }
const _hoisted_14 = {
  key: 1,
  class: "bg-next-gray-md-darker h-36"
}
const _hoisted_15 = { class: "grid-cols-1 grid gap-3" }
const _hoisted_16 = {
  key: 1,
  class: "bg-next-gray-md-darker h-36"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_AlertCard = _resolveComponent("AlertCard")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ContattoCard = _resolveComponent("ContattoCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Loading, { visible: _ctx.loading }, null, 8, ["visible"])
    ])),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.labelGender) + " ", 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.me.name), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[1] || (_cache[1] = _createElementVNode("a", {
            href: "https://nextyu-qaprod.nextgroup.eu/",
            target: "_blank",
            class: "bg-white p-4 h-20"
          }, [
            _createElementVNode("div", { class: "flex-shrink font-bold" }, "CRM")
          ], -1)),
          (_openBlock(), _createBlock(_resolveDynamicComponent('router-link'), {
            to: {name:'ListaProgetti'},
            class: "bg-white p-4 h-20"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("div", { class: "flex-shrink font-bold" }, "PROGETTI", -1)
            ])),
            _: 1
          })),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "bg-next-gray-md-darker p-4 h-20" }, null, -1)),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "bg-next-gray-md-darker p-4 h-20" }, null, -1)),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "bg-next-gray-md-darker p-4 h-20" }, null, -1)),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "bg-next-gray-md-darker p-4 h-20" }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, [
            _cache[6] || (_cache[6] = _createElementVNode("p", { class: "font-bold mb-3" }, "ALERT", -1)),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_AlertCard, {
                vediLink: {name:'AlertScaduti'},
                class: "h-36",
                titolo: "Alert scaduti",
                numero: _ctx.meCounters?.scaduti,
                "colore-stato-class": "text-next-orange text-xl leading-none"
              }, null, 8, ["numero"]),
              _createVNode(_component_AlertCard, {
                vediLink: {name:'AlertScadenza'},
                class: "h-36",
                titolo: "Alert in scadenza",
                numero: _ctx.meCounters?.in_scadenza,
                "colore-stato-class": "text-next-pre text-xl leading-none"
              }, null, 8, ["numero"]),
              _createVNode(_component_AlertCard, {
                vediLink: {name:'RichiamaEntro'},
                class: "h-36",
                titolo: "Stato ok",
                numero: _ctx.meCounters?.ok,
                "colore-stato-class": "text-next-atp text-xl leading-none"
              }, null, 8, ["numero"])
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[8] || (_cache[8] = _createElementVNode("p", { class: "font-bold mb-3" }, "PROGETTI", -1)),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0,1,2], (p) => {
                return _createElementVNode("div", null, [
                  (_ctx.progetti[p])
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.progetti[p].titolo), 1),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.progetti[p].denominazione), 1),
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_router_link, {
                              to: {name:'DettaglioProgetto', params:{id:_ctx.progetti[p].id}},
                              class: "border border-1 border-next-neu px-3 py-1 text-xs"
                            }, {
                              default: _withCtx(() => _cache[7] || (_cache[7] = [
                                _createTextVNode("Vedi ")
                              ])),
                              _: 2
                            }, 1032, ["to"])
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_14))
                ])
              }), 64))
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[9] || (_cache[9] = _createElementVNode("p", { class: "font-bold mb-3" }, "CONTATTI", -1)),
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0,1,2], (c) => {
                return _createElementVNode("div", null, [
                  (_ctx.contatti[c])
                    ? (_openBlock(), _createBlock(_component_ContattoCard, {
                        key: _ctx.contatti[c].id,
                        id: _ctx.contatti[c].azienda_id,
                        cid: _ctx.contatti[c].id,
                        cliente: _ctx.contatti[c].nome,
                        sottotitolo: _ctx.contatti[c].posizione_lavorativa,
                        class: "h-36"
                      }, null, 8, ["id", "cid", "cliente", "sottotitolo"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_16))
                ])
              }), 64))
            ])
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("div", null, [
            _createElementVNode("p", { class: "font-bold mb-3" }, "ALERT"),
            _createElementVNode("div", { class: "grid-cols-1 grid gap-3" })
          ], -1))
        ])
      ])
    ])
  ], 64))
}